// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e5067a2c","667":"f83d186b","977":"6a18d33c"}[chunkId] + ".chunk.js";
};